// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

import { payerSchema } from "./payerSchema.ts";

export const serviceIntroductionSchema = z.object({
  activeMedicaid: z.optional(
    z
      .lazy(() => payerSchema)
      .describe(
        "Active Medicaid coverage details. Absent when no active coverage is found.",
      ),
  ),
  activeMedicare: z.optional(
    z
      .lazy(() => payerSchema)
      .describe(
        "Active Medicare coverage details. Absent when no active coverage is found.",
      ),
  ),
  entryPointType: z.enum(["SERVICE_INTRODUCTION"]),
  memberId: z.string(),
  state: z.string(),
  type: z.enum(["VANCE_SERVICE_INTRODUCTION"]),
  workRequirementLastUpdatedDate: z.string().date().nullish(),
  workspaceId: z.string(),
});
